import React from 'react';
import styled from 'styled-components';
import { FavoriteStarIcon } from '../../../Icon';

const Container = styled(FavoriteStarIcon)`
  margin-left: auto;
`;

const NodeIsFavoriteIcon = () => <Container isActive={true} />;

export default NodeIsFavoriteIcon;
